module.exports = __webpack_public_path__ + "media/img/frontend_application/free_trial/service_three-9af132a0fb41fbdcb898bede3d2d407a.png";